function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 13.4l5.4-5.387V5.05c0-.762-.625-1.387-1.4-1.387H5.05c-.763 0-1.388.625-1.388 1.387V12c0 .775.625 1.4 1.388 1.4H8zM5.75 7.838h2.087V5.75h1.375v2.088H11.3v1.4H9.212V11.3H7.837V9.238H5.75v-1.4zm13.187 2.775h-3.9l5.175-5.163-1.05-1.063-5.762 5.75-3.275 3.263-5.763 5.75 1.063 1.063 5.187-5.176v3.913c0 .775.613 1.387 1.388 1.387h6.937c.788 0 1.4-.612 1.4-1.387V12a1.38 1.38 0 00-1.4-1.387zm-.687 5.55h-5.563v-1.376h5.563v1.376z",
  fill: "currentColor"
}));